import React, { ChangeEvent, FC } from 'react'
import styles from 'styles/components/form.module.scss'
import { DaysOfWeek, DayOfWeekType } from 'lib/daysOfWeek'

interface Props {
  disabled?: boolean
  isChecked: boolean
  id: string
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void
  selectDaysOfWeek?: (dayOfWeek: DayOfWeekType) => void
  value: DayOfWeekType
}

const DayOfWeekCheckbox: FC<Props> = (props) => {
  const { disabled, id, isChecked, onChange, selectDaysOfWeek, value } = props
  const daysOfWeek = new DaysOfWeek()
  const isHoliday = value === 'hol'

  const className = (() => {
    switch (true) {
      case disabled && isHoliday:
        return styles.checkbox__weekday__holiday_disabled
      case disabled:
        return styles.checkbox__weekday_disabled
      case isChecked && isHoliday:
        return styles.checkbox__weekday__holiday_checked
      case !isChecked && isHoliday:
        return styles.checkbox__weekday__holiday
      case isChecked && !isHoliday:
        return styles.checkbox__weekday_checked
      case !isChecked && !isHoliday:
        return styles.checkbox__weekday
      default:
        return styles.checkbox__weekday
    }
  })()

  return (
    <label className={className} htmlFor={id}>
      <input
        className={styles.checkbox__weekday__input}
        checked={isChecked}
        disabled={disabled}
        id={id}
        onChange={(e) => (onChange ? onChange(e) : null)}
        onClick={() => (selectDaysOfWeek ? selectDaysOfWeek(value) : null)}
        value={value}
        type="checkbox"
      />
      <span>{isHoliday ? daysOfWeek.getName(value) : daysOfWeek.getShortName(value)}</span>
    </label>
  )
}

export default DayOfWeekCheckbox
